import { Injectable } from '@angular/core';
import { BrowserPlatformService } from './browser-platform.service';
import { runtimeConfig } from '../config/runtime-config';

declare global {
  interface Window {
    dataLayer?: unknown[][];
    gtag?: (...args: unknown[]) => void;
  }
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  constructor(private readonly browser: BrowserPlatformService) {}

  initialize(): void {
    const measurementId = runtimeConfig.googleAnalyticsMeasurementId;
    if (!measurementId || this.browser.document.querySelector('script[data-phone-support-analytics]')) {
      return;
    }

    this.browser.window.dataLayer ??= [];
    this.browser.window.gtag = (...args: unknown[]) => this.browser.window.dataLayer?.push(args);
    this.browser.window.gtag('js', new Date());
    this.browser.window.gtag('config', measurementId);

    const script = this.browser.document.createElement('script');
    script.async = true;
    script.dataset['phoneSupportAnalytics'] = 'true';
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    this.browser.document.head.appendChild(script);
  }
}
